import React from "react";
import { useTranslation } from "react-i18next";
import { resources } from "translation/en";

import * as S from "./signup.list.styles";
import { ExplainerButton } from "components/atoms/signup-poster/index"; // Import the new component

export const SignupList = () => {
  const { t } = useTranslation();

  const list = resources.en.translation.signup.hints;

  const renderList = Object.entries(list).map(([key, value]) => {
    const hint = `signup.hints.${key}`;
    return <S.List key={key}>{t(hint)}</S.List>;
  });

  return (
    <S.ContainerLeft>
      <S.DiscountHeader>{t("signup.header")}</S.DiscountHeader>
      <S.DiscountDueDate>{t("signup.sub_header")}</S.DiscountDueDate>
      <S.Advantages>{renderList}</S.Advantages>
      <ExplainerButton /> {/* Component for vedio poster */}
      <S.DiscountFooter>{t("signup.footer")}</S.DiscountFooter>
    </S.ContainerLeft>
  );
};
